import { configure, defineRule } from 'vee-validate';
import { required, email, min, numeric, confirmed, alpha, length, regex, alpha_spaces, alpha_dash, max, not_one_of, between, min_value } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import { veeValidateConfig } from '@hfc/ui-core';

defineRule('required', required);
defineRule('alpha', alpha);
defineRule('alpha_spaces', alpha_spaces);
defineRule('alpha_dash', alpha_dash);
defineRule('alpha_spaces_hyphens', veeValidateConfig.validations.alpha_spaces_hyphens);
defineRule('length', length);
defineRule('regex', regex);
defineRule('email', email);
defineRule('min', min);
defineRule('max', max);
defineRule('numeric', numeric);
defineRule('confirmed', confirmed);
defineRule('not_one_of', not_one_of);
defineRule('between', between);
defineRule('min_value', min_value);
defineRule('max_date', veeValidateConfig.validations.max_date);
defineRule('min_date', veeValidateConfig.validations.min_date);
defineRule('custom_required', veeValidateConfig.validations.custom_required);
defineRule('yes_no_required', veeValidateConfig.validations.yes_no_required);
defineRule('at_least_one_letter', veeValidateConfig.validations.at_least_one_letter);
defineRule('at_least_one_number', veeValidateConfig.validations.at_least_one_number);
defineRule('no_exclamation', veeValidateConfig.validations.no_exclamation);
defineRule('confirmed_insensitive', veeValidateConfig.validations.confirmed_insensitive);
defineRule('ssn_validator', veeValidateConfig.validations.ssn_validator);
defineRule('ssn_duplicated', veeValidateConfig.validations.ssn_duplicated);
defineRule('usRestrictedZipCodes', veeValidateConfig.validations.usRestrictedZipCodes);

configure({
  validateOnInput: false,
  validateOnChange: false,
  validateOnBlur: true,
  validateOnModelUpdate: true,
  generateMessage: localize('en', veeValidateConfig.veeValidateMessages),
});

